export default __webpack_public_path__ + "static/media/person-1-safari-14.1011093e.png";